import axios from "axios";

export const BASE_URL = "https://satkartarcrmcall.satkartar.me/";
//export const BASE_URL = "http://localhost/satkartarcrmcall/";

const apiClient = axios.create({ baseURL: BASE_URL });

export const clearHospitalSession = () => {
  localStorage.removeItem("hospital_user_id");
  localStorage.removeItem("hospital_user");
};

export const getHospitalUser = () => {
  try {
    return JSON.parse(localStorage.getItem("hospital_user") || "{}");
  } catch {
    return {};
  }
};

export const isCoordinatorSession = () => {
  const hospital = getHospitalUser();
  return Boolean(localStorage.getItem("hospital_user_id")) && hospital.hospital_role === "Coordinator";
};

const normalizeError = (error) => ({
  data: {
    status: 0,
    msg: error?.response?.data?.msg || error?.message || "Unable to connect to hospital server.",
  },
  status: error?.response?.status || 0,
});

export const hospitalPost = async (url, data) => {
  const coordinatorUrl = url.startsWith("hospital-coordinator-") ? url : url.replace(/^hospital-/, "hospital-coordinator-");
  try {
    return await apiClient({
      method: "POST",
      url: coordinatorUrl,
      data,
      headers: { "Content-Type": "multipart/form-data" },
    });
  } catch (error) {
    return normalizeError(error);
  }
};
